define(['underscore', 'backbone.localstorage'], function({ bind }) {
  var BaseCollection = Backbone.Collection.extend({
    constructor(models, options) {
      Backbone.Collection.call(this, models, options);

      // Bind to document ready after we're sure `.initialize()` has already been called.
      $(bind(this.ready, this));
    },

    // Things that require the DOM to be ready should be setup here.
    ready() {
    },
  });

  return BaseCollection;
});
